<template>
  <div>
    <LoadingIndicator v-if="loading" />
    <p v-else-if="error" class="text-red-600">{{ error }}</p>
    <div v-else class="space-y-8">
      <HermesCard title="Cases" :meta="casesMeta" flush>
        <template #actions>
          <button v-if="selected.length" type="button" class="text-gray-600 hover:text-gray-900" @click="selected = []">Clear selection</button>
        </template>
        <TestCases :bench="bench" :selected="selected" @refresh="load" @select="toggle" />
      </HermesCard>
      <TestRuns :bench="bench" :selected="selected" />
    </div>
  </div>
</template>

<script>
import LoadingIndicator from '@/components/widgetcomponents/library/LoadingIndicator.vue';
import HermesCard from '../HermesCard.vue';
import { errorOf } from '../hermes';
import { casesOf, findBench } from './bench';
import TestCases from './TestCases.vue';
import TestRuns from './TestRuns.vue';

export default {
  name: 'HermesTests',
  components: { LoadingIndicator, HermesCard, TestCases, TestRuns },
  emits: ['crumb', 'pending'],
  data() {
    return { bench: null, loading: true, error: '', selected: [] };
  },
  computed: {
    caseCount() {
      return casesOf(this.bench && this.bench.template).length;
    },
    casesMeta() {
      return this.selected.length ? `${this.selected.length} of ${this.caseCount} selected` : `${this.caseCount} · tick to run only some`;
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    toggle(label) {
      this.selected = this.selected.includes(label) ? this.selected.filter((l) => l !== label) : [...this.selected, label];
    },
    async load() {
      this.loading = true;
      this.error = '';
      try {
        this.bench = await findBench(this.$axios);
      } catch (e) {
        this.error = errorOf(e, 'The bench could not be loaded.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
